import $ from 'jquery';

(function($) {

    $(document).ready(function(){

        const isBreakPoint = (bp) => {
            var bps = [414, 540, 768, 991, 1024],
                w = $(window).width(),
                min, max
            for (var i = 0, l = bps.length; i < l; i++) {
              if (bps[i] === bp) {
                min = bps[i-1] || 0
                max = bps[i]
                break
              }
            }
            return w > min && w <= max
        }

        // Usage
        if (isBreakPoint(991)) {
            console.log("991 teste")

        } // Breakpoint between 320 and 480

        $('.navbar-toggler').click(function(){
            $('.h-nav_menu--hidden').addClass('bgBlue');
        })

        $(window).bind('scroll', function () {
            if ($(window).scrollTop() > 580) {
                $(".btnInvisble").hide()
                $('#navBanner').addClass('fixed-top');
            } else {
                $(".btnInvisble").show()
                $('#navBanner').removeClass('fixed-top');
            }
        });

        $('.btnTop').click(function(e){
            e.preventDefault();
            $('html, body').animate({scrollTop:0}, 'slow');
            return false;
        });

        $('.btnInscrever').on('click', function() {
            window.open('https://formularios.fortaleza.ce.gov.br/index.php?r=survey/index&sid=295544&lang=pt-BR');
        })

    });

})($);
